exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**  rel=\"stylesheet/scss\" lang=\"scss\"*/\n/** backgroud */\n/** border */\n/** table */\n/* Popover\n-------------------------- */\n/* Dialog\n-------------------------- */\n[data-v-92f26f4e]:export {\n  xrColorPrimary: #2362FB;\n}\n.el-cascader[data-v-92f26f4e] {\n  width: 100%;\n}\n", ""]);

// exports
